export const SET_PROPRIETY_POINT_DE_VENTE = 'SET_PROPRIETY_POINT_DE_VENTE';
export const VIDER_PDV = 'VIDER_PDV';
export const SET_FILTER_RAYON = 'SET_FILTER_RAYON';
export const SET_CONCURRENTS = 'SET_CONCURRENTS';
export const SET_NBRE_CONCURRENTS = 'SET_NBRE_CONCURRENTS';
export const SET_IS_MODIF_PDV = 'SET_IS_MODIF_PDV';
export const SET_CONCURRENT_SELECTIONNES = 'SET_CONCURRENT_SELECTIONNES';
export const SET_LAST_RAYON = 'SET_LAST_RAYON';
export const SET_ADRESSE_POINT_CENTRAL = 'SET_ADRESSE_POINT_CENTRAL';
export const SET_AFFICHER_MARKER_PDV = 'SET_AFFICHER_MARKER_PDV';
